export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";